import React, {useEffect, useState} from "react";
import {Columns, Heading, Modal, Section, Form, Table, Button} from "react-bulma-components";
import ApproveModalRow from "./ApproveModalRow";
import axios from "axios";
import {NotificationManager} from "react-notifications";
import {useDispatch} from "react-redux";
import {createSetDataFreshAction} from "../../actions/dataActions";
import {addXeroVat} from "../../utils";


export default function ApprovalModal({selectedTransaction, show, setShow, onApprove, getFilteredData, endpoint,
                                          validator, setGetFilteredData, paymentTypes, paymentTypeObjects,
                                          onSave, dataFresh, trackingOptions, trackingOptionObjects, type, nominalCodes, nominalCodeObjects}){
    let [filteredTransactions, setFilteredTransactions] = useState({results: []});
    const dispatch = useDispatch();

    const onChange = (e, index) => {
        let newTransaction = {...filteredTransactions.results[index]};
        newTransaction[e.target.name] = e.target.value;

        let newTransactions = [...filteredTransactions.results];
        newTransactions[index] = newTransaction;

        setFilteredTransactions({results: newTransactions});
    }

    const handleSave = (e, index, setEditable) => {
        let data = filteredTransactions.results[index];
        onSave(false, data).then(res => {
            setEditable(false);
            dispatch(createSetDataFreshAction(dataFresh + 1));
        }).catch(err => {
            NotificationManager.error("There was an error saving a transaction")
        });
    }

    const requestFilteredData = () => {
        if(selectedTransaction && selectedTransaction.invoice_number && selectedTransaction.department) {
            let url = endpoint + `transactions?inv=${selectedTransaction.invoice_number}&department=${selectedTransaction.department.id}&page_size=1000`;
            const conf = {
                url: url,
                method: "get"
            }
            axios(conf).then(res => {
                setFilteredTransactions(res.data)
            })
        }
    }
    useEffect(() => {
        requestFilteredData();
    }, [getFilteredData]);


    const approveAll = (e) => {
        let allValid = true;
        filteredTransactions.results.forEach(transaction => {
            allValid = allValid && validator(transaction)
        })
        if(allValid) {
            // filteredTransactions.results.forEach(transaction => {
            //     onApprove(e, true, transaction)
            // })
            onApprove(e, true, filteredTransactions.results).then(res => {
                setShow(false);
            })
        }
    }


    const getTotal = () => {
        let total = filteredTransactions.results.reduce((prev, current) => {
            return parseFloat(prev) + parseFloat(addXeroVat(current.invoice_vat, current.invoice_amount))
        }, 0)
        return total.toFixed(2);
    }

    return (
        <Modal
            show={show}
            onClose={() => {
                setShow(false);
                setGetFilteredData(undefined);
            }}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Transaction Approve</Heading>
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Department</Form.Label>
                            <Form.Input
                                type={"text"}
                                disabled={true}
                                value={selectedTransaction.department ? selectedTransaction.department.name: ""}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Total Invoice Amount</Form.Label>
                            <Form.Input
                                disabled={true}
                                value={getTotal()}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Table size={"fullwidth"}>
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Description</th>
                                        <th>Contact</th>
                                        <th>Tracking Category</th>
                                        <th>Payment Type</th>
                                        {type === "IN" &&<th>Customer Account</th>}
                                        <th>Nominal Code</th>
                                        <th>Invoice Amount</th>
                                        <th>Invoice VAT (%)</th>
                                        <th>Invoice Total</th>
                                        {type === "IN" && <th>Customer Paid</th>}
                                        <th>Invoice Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredTransactions.results.map((transaction, index) => (
                                        <ApproveModalRow
                                            transaction={transaction}
                                            paymentTypes={paymentTypes}
                                            paymentTypeObjects={paymentTypeObjects}
                                            onSave={handleSave}
                                            onChange={onChange}
                                            index={index}
                                            trackingOptions={trackingOptions}
                                            trackingOptionObjects={trackingOptionObjects}
                                            nominalCodes={nominalCodes}
                                            nominalCodeObjects={nominalCodeObjects}
                                        />
                                    ))}
                                </tbody>
                            </Table>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                onClick={() => {
                                    setGetFilteredData(undefined);
                                    setShow(false);
                                }}
                                fullwidth
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                onClick={approveAll}
                                fullwidth
                            >
                                Approve
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )


}